import { css } from 'styled-components';

const variables = css`
  :root {
    --dark-navy: #020c1b;
    --navy: #0a192f;
    --light-navy: #112240;
    --lightest-navy: #233554;
    --navy-shadow: rgba(2, 12, 27, 0.7);
    --dark-slate: #495670;
    --slate: #8892b0;
    --light-slate: #a8b2d1;
    --lightest-slate: #ccd6f6;
    --white: #e6f1ff;
    --green: #00c896;
    --green-tint: rgba(0, 200, 150, 0.1);
    --pink: #f57dff;
    --blue: #57cbff;

    /* 动态背景相关变量 - 调暗版本 */
    --color-bg1: rgba(10, 25, 47, 0.9);
    --color-bg2: rgba(17, 34, 64, 0.9);
    --color1: 12, 75, 170;
    --color2: 147, 39, 170;
    --color3: 66, 147, 170;
    --color4: 133, 33, 33;
    --color5: 120, 120, 33;
    --color-interactive: 93, 66, 170;
    --circle-size: 80%;
    --blending: hard-light;

    /* 统一的两种主要颜色：深绿色 + 白色 */
    --text-primary: #ffffff;
    --text-secondary: #ffffff;
    --text-tertiary: #ffffff;
    --text-quaternary: rgba(255, 255, 255, 0.7);
    --text-accent: #00c896;
    --text-success: #34c759;
    --text-warning: #ff9500;
    --text-error: #ff3b30;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
